import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

import { UserRouteAccessService } from '../../shared';
import { HistoriqueComponent } from './historique.component';

export const historiqueRoute: Route = {
  path: 'historique/:id',
  component: HistoriqueComponent,
  data: {
      needAuthentication: true,
      pageTitle: `Consultation de dossier${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/historique.route.ts